"use client";

import { storyblokEditable } from "@storyblok/react";
import Image from "next/image";
import { Pagination, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { sbBlok } from "@/types/sb-types";
import "swiper/css";
import ArrowBackIosNewOutlinedIcon from "@mui/icons-material/ArrowBackIosNewOutlined";
import ArrowForwardIosOutlinedIcon from "@mui/icons-material/ArrowForwardIosOutlined";

const Testimonials = ({ blok }: sbBlok) => {
  return (
    <div className="grid-container px-2.5 py-10 lg:py-[90px] lg:px-auto">
      <div className="col-start-1 col-span-4 row-start-1 lg:col-start-2 lg:col-span-14 2xl:col-start-2 2xl:col-span-30">
        <Swiper
          {...storyblokEditable(blok)}
          className="w-full h-auto lg:!w-[850px]"
          slidesPerView={1}
          spaceBetween={30}
          speed={500}
          centeredSlides
          pagination={{ clickable: true }}
          modules={[Pagination, Navigation]}
          navigation={{
            nextEl: `.swiper-nextEl`,
            prevEl: `.swiper-prevEl`,
          }}
          onClick={(swiper, e) => {
            e.stopPropagation();
            swiper.clickedIndex !== undefined &&
              swiper.slideTo(swiper.clickedIndex, 100);
          }}
        >
          {blok?.testimonial_items?.map((i: sbBlok) => {
            return (
              <SwiperSlide
                key={i._uid}
                className="rounded-[10px] bg-tm-c-gray-900 shadow-[7px_10px_40px_0_rgba(0,0,0,0.1)] py-12 px-[30px] h-fit flex self-center lg:py-12 lg:px-[70px] lg:shadow-[20px_10px_44px_0_rgba(0,0,0,0.15)]"
              >
                <div className="flex flex-col items-center justify-center gap-[30px] text-center lg:flex-row lg:items-start lg:text-left">
                  {i?.image?.filename && (
                    <div className="relative w-[100px] h-[100px] rounded-full overflow-hidden flex-shrink-0 lg:w-[120px] lg:h-[120px]">
                      <Image
                        src={i.image.filename}
                        alt={i.image.alt}
                        fill
                        sizes="100vw"
                        className="object-cover"
                      />
                    </div>
                  )}
                  <div className="flex flex-col gap-[30px]">
                    <div className="text-[15px] italic leading-[1.5] tracking-[0.45px] font-normal lg:text-[20px] lg:tracking-[0.6px]">
                      {i?.content}
                    </div>
                    <div className="text-[15px] font-normal tracking-[1.5px] uppercase">
                      {i?.name}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
          <div className="swiper-prevEl left-5 lg:left-[250px] absolute bottom-0 cursor-pointer">
            <ArrowBackIosNewOutlinedIcon />
          </div>
          <div className="swiper-nextEl right-5 lg:right-[250px] absolute bottom-0 cursor-pointer">
            <ArrowForwardIosOutlinedIcon />
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default Testimonials;
